import { TextAlignment } from '@/src/components';
import { Icon } from '@/src/tools/icon';
import { get, isNumber } from 'lodash';
import React from 'react';
import { NumberInput } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import Slider from 'src/components/Slider/MarginSlider';
import Editor from 'src/constrains/BraftEditor';
import { errCodesMap } from 'src/error/code';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const ResponsiveRichEdit = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    content,
    onChange,
    isConvertible,
    linkSet,
    hideWidth,
    displayError,
    disabled,
    richEditorProps,
  } = props;
  //console.log('content', content);
  const text = get(content, 'text');
  const textBoxWidth = get(content, 'textBoxWidth');
  const fontSizeMultiply = get(content, 'fontSizeMultiply');
  const textAlignment = get(content, 'textAlignment');
  const contentHasError = get(content, 'contentHasError');
  return isConvertible ? (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper
          title={`${getI18n('general.text')}*`}
          error={contentHasError && displayError}
          errorText={errCodesMap['999999']}>
          <Editor
            placeholder={getI18n('general.managetextcontentformat')}
            disabled={isConvertible || disabled}
            linkSet={linkSet}
            {...(richEditorProps || {})}
            data={text}
            onChange={({ data }) => {
              const _content = { ...content, text: data };
              onChange({ content: _content });
            }}
          />
        </ItemWrapper>
        <Slider
          max={1000}
          min={0}
          title={getI18n('general.fontSizeMultiple')}
          customIcon={<Icon type={'icona-fontsize'} className={css.icon} />}
          value={fontSizeMultiply}
          onChange={(v) => {
            const _content = { ...content, fontSizeMultiply: v };
            onChange({ content: _content });
          }}
          suffix={'%'}
        />
        <ItemWrapper title={getI18n('general.textAlignment')}>
          <TextAlignment
            value={textAlignment}
            onChange={(v) => {
              const _content = { ...content, textAlignment: v };
              onChange({ content: _content });
            }}
          />
        </ItemWrapper>
        {!hideWidth && (
          <ItemWrapper title={getI18n('general.textBoxWidth')} size='small'>
            <NumberInput
              suffix={'px'}
              value={textBoxWidth}
              size={'large'}
              min={0}
              onChange={(textBoxWidth) => {
                if (isNumber(textBoxWidth)) {
                  const _content = { ...content, textBoxWidth: textBoxWidth };
                  onChange({ content: _content });
                } else {
                  const _content = { ...content, textBoxWidth: 0 };
                  onChange({ content: _content });
                }
              }}
            />
          </ItemWrapper>
        )}
      </Section>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper
          title={`${getI18n('general.text')}*`}
          error={contentHasError && displayError}
          errorText={errCodesMap['999999']}>
          <Editor
            placeholder={getI18n('general.managetextcontentformat')}
            linkSet={linkSet}
            disabled={isConvertible || disabled}
            // onErrorChange={(e) => {
            //   const _content = { ...content, contentHasError: e };
            //   onChange({ content: _content });
            // }}
            data={text}
            onChange={({
              data, //isEmpty
            }) => {
              const _content = {
                ...content,
                text: data,
                // contentHasError: isEmpty,
              };
              onChange({ content: _content });
            }}
            {...(richEditorProps || {})}
          />
          <div style={{ paddingTop: '10px', fontSize: '13px' }}>
            {getI18nFromGeneral('general.linebreak.pleaseuse')}
            <span style={{ fontWeight: 'bold' }}>Shift + Enter</span>
            {getI18nFromGeneral('general.linebreak.createalineBreak')}
          </div>
        </ItemWrapper>
      </Section>
      {!hideWidth && (
        <Section size='small' bottomBorder>
          <ItemWrapper title={getI18n('general.textBoxWidth')} size='small'>
            <NumberInput
              suffix={'px'}
              value={textBoxWidth}
              size={'large'}
              min={0}
              onChange={(textBoxWidth) => {
                if (isNumber(textBoxWidth)) {
                  const _content = { ...content, textBoxWidth: textBoxWidth };
                  onChange({ content: _content });
                } else {
                  const _content = { ...content, textBoxWidth: 0 };
                  onChange({ content: _content });
                }
              }}
            />
          </ItemWrapper>
        </Section>
      )}
    </React.Fragment>
  );
};
export default ResponsiveRichEdit;
